var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imc_inbox_table", attrs: { id: "i_table" } },
    [
      !_vm.is_load
        ? _c("b-skeleton-table", {
            attrs: {
              rows: this.cur_records,
              columns: 2,
              "hide-header": true,
              "table-props": { bordered: false, striped: true },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.is_load
        ? _c(
            "div",
            { staticClass: "inbox_vue_list" },
            [
              _c("b-table", {
                staticClass: "table-responsive-xl resolution_table",
                attrs: {
                  "thead-class": _vm.head_class,
                  "tbody-tr-class": _vm.rowClass,
                  striped: "",
                  items: _vm.rows,
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "table-busy",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center text-danger my-2" },
                            [
                              _c("b-spinner", { staticClass: "align-middle" }),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Працюэмо...")]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(id)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-checkbox" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.is_check_all,
                                    expression: "is_check_all",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "imc_checker_all",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.is_check_all)
                                    ? _vm._i(_vm.is_check_all, null) > -1
                                    : _vm.is_check_all,
                                },
                                on: {
                                  click: _vm.check_all,
                                  change: function ($event) {
                                    var $$a = _vm.is_check_all,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.is_check_all = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.is_check_all = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.is_check_all = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass:
                                  "custom-control-label cursor-pointer bolder",
                                attrs: { for: "imc_checker_all" },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(number)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: { list_ordering: "m.id", field_name: "№" },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(added)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "m.added",
                              field_name: "Дата",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(quest_name)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "q_real.title",
                              field_name: "Питання",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(small_tov_title)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "t.title",
                              field_name: "Органiзацiя",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(init_name)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "m.init_user",
                              field_name: "Ініціатор",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(rec_short_name)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "m.recipient_id",
                              field_name: "Затвердження",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(isp_name)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "m.isp_id",
                              field_name: "Виконавець",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(date_to)",
                      fn: function (data) {
                        return [
                          _c("grid_id", {
                            attrs: {
                              list_ordering: "\th_sort.end_work",
                              field_name: "Дата до",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "head(count_unread_chat)",
                      fn: function (data) {
                        return [
                          _c("span", {
                            staticClass: "fs-xl text-center",
                            domProps: { innerHTML: _vm._s(data.label) },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(id)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-checkbox" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: data.item._is_checked,
                                    expression: "data.item._is_checked",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  name: "cid[]",
                                  type: "checkbox",
                                  id: data.item.id + "_cust_id",
                                },
                                domProps: {
                                  value: data.item.id,
                                  checked: Array.isArray(data.item._is_checked)
                                    ? _vm._i(
                                        data.item._is_checked,
                                        data.item.id
                                      ) > -1
                                    : data.item._is_checked,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = data.item._is_checked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = data.item.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            data.item,
                                            "_is_checked",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            data.item,
                                            "_is_checked",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(data.item, "_is_checked", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass:
                                  "custom-control-label cursor-pointer bolder",
                                attrs: { for: data.item.id + "_cust_id" },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(code)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.load_preview(data.item.id, data)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "base base-15 icon-stack-3x opacity-100 color-primary-900",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fal fa-indent icon-stack-1x opacity-100 color-white",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(number)",
                      fn: function (data) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "mem_link",
                              attrs: { href: data.item.link },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.nice_search(
                                      data.item.tov_code +
                                        "_" +
                                        data.item.code +
                                        "_" +
                                        data.item.id
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          data.item.files > 0
                            ? _c("span", { staticClass: "hidden-md-down" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "files_cont show_inside_files cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.load_preview_files(
                                          data.item.id,
                                          data
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-paperclip",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "hidden-lg-up small" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.added_format) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(added)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(data.item.added_format) +
                              "\n                "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(quest_name)",
                      fn: function (data) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "mem_link",
                              attrs: { href: data.item.link },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.nice_search(data.item.quest_name)
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "fw-300 fs-sm mt-2" }, [
                              _c("i", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.nice_search(data.item.title)
                                    ),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(small_tov_title)",
                      fn: function (data) {
                        return [
                          _c("div", { staticClass: "icon-stack fs-xl mr-2" }, [
                            _c("i", {
                              staticClass:
                                "fal fa-building icon-stack-3x opacity-100 color-primary-500",
                            }),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(data.item.small_tov_title) +
                              "\n\n                    "
                          ),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "icon-stack fs-xl mr-2" },
                              [
                                _c("i", {
                                  staticClass:
                                    "fal fa-address-card icon-stack-3x opacity-40 color-primary-500",
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(data.item.serv_title) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(date_to)",
                      fn: function (data) {
                        return [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(data.item.date_to) },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(can_pdf)",
                      fn: function (data) {
                        return [
                          _vm.is_can_pdf
                            ? _c(
                                "a",
                                {
                                  staticClass: "pdf_link",
                                  attrs: {
                                    target: "_blank",
                                    href: data.item.pdf_link,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base base-19 icon-stack-3x opacity-100 color-primary-900",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fal fa-file-pdf icon-stack-1x opacity-100 color-white",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: "cell(count_unread_chat)",
                      fn: function (data) {
                        return [
                          _c("div", { staticClass: "icon-stack fs-xxl" }, [
                            _c("i", {
                              staticClass:
                                "base base-6 icon-stack-3x opacity-100 color-primary-900",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "fal fa-bell icon-stack-1x opacity-100 color-white",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "badge badge-icon" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.count_unread_chat) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(favorite_class)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon-stack set_favorite fs-xxl cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.set_favorite(data.item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "base base-19 icon-stack-3x opacity-100 color-primary-900",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fas fa-star icon-stack-1x",
                                class: {
                                  "color-danger-100": data.item.is_favorite,
                                  "color-white": !data.item.is_favorite,
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(remove_class)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "icon-stack rem_doc",
                              class: {
                                disable: data.item.can_remove === false,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.remove_doc(data.item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "base base-1 icon-stack-3x opacity-100 color-danger-600",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "far fa-trash-alt icon-stack-1x opacity-100 color-white",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "row-details",
                      fn: function (row) {
                        return [
                          row.item._showFastPreview
                            ? _c("fast_preview", {
                                attrs: { item: row.item.fast_preview },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          row.item._showFastFilePreview
                            ? _c("fast_files", {
                                attrs: { files: row.item.fast_files_preview },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3175832748
                ),
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inb_pagi pt-4" },
                [
                  _c("imc_filter_pagination", {
                    attrs: {
                      pagi_url:
                        "index.php?option=com_imc_docs&task=inbox.getPagination",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }